<h2 mat-dialog-title>{{ 'T4.Service.PdfDialog.Title' | translate : 'Police Templates'}}</h2>

<mat-dialog-content>
  <mat-form-field appearance="outline" style="margin-bottom:10px;">
    <mat-label>Template</mat-label>
    <mat-select (selectionChange)="onTemplateChange($event.value)">
      <mat-option *ngFor="let template of templates" [value]="template.Content">
        {{ template.FriendlyName }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Content</mat-label>
    <textarea matInput
              rows="25"
              [(ngModel)]="text">
    </textarea>
  </mat-form-field>
    
</mat-dialog-content>

<mat-dialog-actions style="justify-content:end; gap:10px;">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-raised-button color="primary" (click)="openPdf()">
    Open as PDF
  </button>
</mat-dialog-actions>
